import ConsultationIcon from '@/components/ui/icons/Consultation'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'


export function CreateConsultationButton() {

  const { t } = useTranslation()

  return (
    <Button
      component={Link}
      to="/consultations/create"
      variant="contained"
      startIcon={<ConsultationIcon htmlColor="#FFF" id="create-consultation-button" />}
    >
      {t('page.consultations.createConsultationButton.label')}
    </Button>
  )
} 